export const adultRoles = [
  'teacher',
  'parent_carer',
  'school_lead',
  'pilot_admin',
  'support_operations',
] as const;
export type AdultRole = (typeof adultRoles)[number];
type Status = 'active' | 'inactive' | 'revoked';
export type AdultAccessSnapshot = {
  adultId: string;
  roles: { assignmentId: string; role: AdultRole; status: Status }[];
  schoolRelationships: {
    relationshipId: string;
    schoolId: string;
    role: AdultRole;
    status: Status;
  }[];
};
export type ActiveAdultContext = {
  adultId: string;
  role: AdultRole;
  schoolId: string | null;
};

const schoolRoles = new Set<AdultRole>(['teacher', 'school_lead']);

export function chooseActiveContext(
  snapshot: AdultAccessSnapshot,
  request: { role: AdultRole; schoolId?: string },
): ActiveAdultContext {
  if (!adultRoles.includes(request.role)) throw new Error('ACCESS_DENIED');
  const assignment = snapshot.roles.find(
    (item) => item.role === request.role && item.status === 'active',
  );
  if (!assignment) throw new Error('ACCESS_DENIED');
  if (schoolRoles.has(request.role)) {
    if (!request.schoolId) throw new Error('ACCESS_DENIED');
    const relationship = snapshot.schoolRelationships.find(
      (item) =>
        item.schoolId === request.schoolId &&
        item.role === request.role &&
        item.status === 'active',
    );
    if (!relationship) throw new Error('ACCESS_DENIED');
    return {
      adultId: snapshot.adultId,
      role: request.role,
      schoolId: request.schoolId,
    };
  }
  return { adultId: snapshot.adultId, role: request.role, schoolId: null };
}
